import "@mdi/font/css/materialdesignicons.css";

import Vue from "vue";
import Vuetify from "vuetify/lib";
import AddProductIcon from "@/globals/icons/AddIcon.vue";
import globalConfig from "@/globals/Configuration";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      addIcon: {
        // name of our custom icon
        component: AddProductIcon // our custom component
      }
    }
  },
  theme: {
    themes: {
      light: globalConfig.colors
    },
    options: {
      customProperties: true
    }
  }
});
